import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useEffect, useState } from 'react';
import { EditorMetricsTracker } from 'ContentEditorUI/utils/metricsTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InvalidModuleBodyWarning() {
  const [closed, setIsClosed] = useState(false);
  useEffect(() => {
    EditorMetricsTracker.counter('invalid-module-body-warning-rendered').increment();
  }, []);
  if (closed) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invalidModuleBodyWarning.title"
    }),
    closeable: true,
    onClose: () => {
      setIsClosed(true);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invalidModuleBodyWarning.message"
    })
  });
}